import React from 'react';
import { BIG_MARGIN_VERTICAL_FN, isWeb } from '../../config/designSystem/Layout';
import { Entypo } from '@expo/vector-icons';
import { H1 } from '../../config/designSystem/typography';
import { PRIMARY0 } from '../../config/designSystem/Colors';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

const BackIcon = ({ tintColor, size }: { tintColor: string; size: number }) => {
  return <Entypo name="chevron-small-left" color={tintColor} size={size} style={{ marginLeft: 5 }} />;
};
export interface NewTitleProps {
  title: string;
  withBack: boolean;
  onBack?: () => void;
  style?: StyleProp<ViewStyle>;
  textColor?: string;
}
export default function NewTitle(props: NewTitleProps) {
  const { height } = useAvailableDimensions();

  return (
    <View
      style={[{
        marginTop: Math.min(BIG_MARGIN_VERTICAL_FN(height), 20),
        flexDirection: 'row',
        alignItems: 'center',
      },
      props.style
      ]}
    >
      {props.withBack && (
        <TouchableOpacity onPress={props.onBack} style={{ marginRight: 20 }} >
          <View style={{ paddingLeft: 0 }}>
            <BackIcon tintColor={PRIMARY0} size={30} />
          </View>
        </TouchableOpacity>
      )}
      <View
        style={(props.withBack && isWeb) ? {
          alignItems: 'center', flex: 1
        } : undefined}
      >
        <H1 style={{fontSize: 32, color: props.textColor}}>
          {props.title}
        </H1>
      </View>
    </View>
  );
}

